var _metadata, _defs, _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftekLogo2019(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 526.7 101.5",
    style: {
      enableBackground: "new 0 0 526.7 101.5"
    },
    xmlSpace: "preserve",
    id: "svg78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata84"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs82"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style48"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n  ")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", {
    id: "switch76"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.3,51c-11.8,9-36.6,13.3-61.2,11.4c5.7,3.8,13.7,7.1,24,9.4c29.8,6.8,66.1,2.9,81.1-8.5     c0.2-0.2,0.3-0.3,0.5-0.5c-19.7-7.6-26-19.5-13.4-29c12.6-9.6,40-13.8,66-11c-5.5-3.3-13.1-6.3-22.4-8.4     c-29.8-6.8-66.1-2.9-81.2,8.5c-0.6,0.4-1,0.9-1.5,1.3C80.7,31.8,84.7,42.3,73.3,51z",
    id: "path51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.6,22.7c-0.1,0-0.2,0-0.3,0C170.4,22.6,170.5,22.7,170.6,22.7C170.6,22.7,170.6,22.7,170.6,22.7z",
    id: "path53"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.7,69c0.1,3,0.8,5.2,2.4,6.6c1.7,1.4,4.1,2.2,7.5,2.2c5.4,0,11.3-1.1,11.3-5.5c0-1-0.4-1.8-1.1-2.5      c-3.5-3.5-33.2-6-41.6-12.5c-3.4-2.6-4.4-6.4-4.4-9.5c0-11.9,12.5-17.3,37.4-17.3c26.4,0,34.4,6.4,34.8,17.7h-25.7      c-0.2-3-1.3-4.9-3.2-6c-1.8-1.1-4.4-1.5-7.7-1.5c-5.5,0-8.4,1.8-8.4,4.6c0,0.8,0.3,1.9,1.1,2.5c4.1,3.4,32.8,5.8,41.1,12.3      c2.4,1.9,4.9,4.8,4.9,10.1c0,10.8-10.8,17.8-39.2,17.8c-33.7,0-35.4-8.8-35.9-18.9H162.7z",
    id: "path55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.3,47.1c20.8,0,34.4,5,34.4,20.4c0,15.4-13.5,20.4-34.4,20.4c-20.8,0-34.3-5-34.3-20.4      C210,52.1,223.5,47.1,244.3,47.1z M244.3,78.2c6.1,0,8.2-4.9,8.2-10.7s-2.1-10.7-8.2-10.7c-6.1,0-8.2,4.9-8.2,10.7      S238.2,78.2,244.3,78.2z",
    id: "path57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.9,59.1h-7.2V48.6h7.2v-1.8c0-10.2,4.4-16.2,23.4-16.2c4.6,0,10.2,0.4,15,1.1v9.9      c-1.5-0.4-3-0.5-5.2-0.5c-5,0-7.9,1.8-7.9,5.7v1.8h12.3v10.6h-12.3v27.3h-25.3V59.1z",
    id: "path59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.6,35.1v13.5h12.7v10.6h-12.7v11c0,4.7,2.7,6.7,8.4,6.7c1.2,0,2.8-0.2,4.5-0.5v10.1      c-3.1,0.6-11.1,1.4-17.2,1.4c-16,0-20.8-3.7-20.8-15.6V59.1h-7.2V48.6h6.9v-6.6L349.6,35.1z",
    id: "path61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.4,70.5c0,6.4,2.9,9.3,8.7,9.3c4.9,0,6.9-1.9,7.6-4.4h24.8c-0.8,6.3-9.6,12.4-31.9,12.4      c-20.2,0-33.9-5.8-33.9-20.2c0-14.7,14.1-20.6,33.2-20.6c16.5,0,33.2,4.6,33.2,21.4v2H385.4z M402.3,63.3c0-4.9-2.7-8.2-8.4-8.2      c-5.4,0-8.4,3.2-8.4,8.2H402.3z",
    id: "path63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.4,66.4l34.9-17.8h32.1l-31.8,16.8l39.1,21.1h-37L458,76.3l-6.5,3.4L440.4,66.4z M427.8,32h25.3v54.5      h-25.3V32z",
    id: "path65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.6,43.4c-3.3,0-5.6-2.4-5.6-5.7c0-3.4,2.6-5.7,5.6-5.7c3,0,5.6,2.3,5.6,5.7S511.6,43.4,508.6,43.4z       M508.6,33c-2.5,0-4.4,1.9-4.4,4.7c0,2.6,1.7,4.7,4.4,4.7c2.4,0,4.4-1.9,4.4-4.7C512.9,34.9,511,33,508.6,33z M507.5,41h-1v-6.3      h2.4c1.5,0,2.3,0.5,2.3,1.8c0,1.1-0.7,1.6-1.6,1.7l1.8,2.8h-1.2l-1.6-2.7h-1V41z M508.6,37.4c0.8,0,1.5-0.1,1.5-1      c0-0.8-0.7-0.9-1.4-0.9h-1.2v1.8H508.6z",
    id: "path69"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftekLogo2019);
export default __webpack_public_path__ + "static/media/softek-logo-2019.79cbb9ad9251dfebe9ae85e3408f5fe5.svg";
export { ForwardRef as ReactComponent };